import 'expose?XRegExp!xregexp';



// WEBPACK FOOTER //
// ../~/@printos/elephant/src/shims/xregexp.js